<template>
  <div
    v-if="!$route.meta.noSearch"
    class="f-b-c header-search-view el-no-border fb-14"
  >
    <el-select
      v-model="searchType"
      placeholder="请选择"
      class="primary-selected bgf5 fb-14"
    >
      <el-option
        v-for="item in options"
        :key="item[optionConfig.CODE]"
        :label="item[optionConfig.LABEL]"
        :value="item[optionConfig.CODE]"
      />
    </el-select>
    <el-input
      v-model="searchValue"
      maxlength="40"
      placeholder="请输入关键字搜索..."
      clearable
      @keyup.enter.native="search"
    />
    <el-button
      type="primary"
      class="fill-h my-search-btn"
      @click="search"
    >项目搜索</el-button>
  </div>
</template>

<script>
import {
  getConstantDic, HEAD_SEARCH_CODE, NAV_MENU_CODE,
  SEARCH_INPUT_OPTIONS_TYPES,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "HeadSearch",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
  },
  data() {
    return {
      searchType: "",
      searchValue: "",
      options: getConstantDic(SEARCH_INPUT_OPTIONS_TYPES),
      optionConfig: SELECT_OPTION_CONFIG
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["site", "allMenusList"])
  },
  watch: {
    // 监听路由对象中的变化
    "$route"(to, from) {
      this.searchValue = to.query.title || ""
    },
    searchType(v) {
      sessionStorage.setItem("searchType", v)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.searchValue = this.$route.query.title || ""
    this.searchType = sessionStorage.getItem("searchType") || HEAD_SEARCH_CODE.GYZCJY
  },
  // 方法集合
  methods: {
    search() {
      const keyword = this.searchValue;
      this.searchValue = "";
      let query = { title: keyword };
      let path = ""
      let filterType = this.searchType
      switch (this.searchType) {
        case HEAD_SEARCH_CODE.GYZCJY:
          break;
        case HEAD_SEARCH_CODE.ZRZCJY:
          break;
        case HEAD_SEARCH_CODE.PURCHASE:
          // path = (this.allMenusList.find(m => m.code === this.searchType) || {}).path
          break;
        case HEAD_SEARCH_CODE.NOTICES:
          // path = (this.allMenusList.find(m => m.code === this.searchType) || {}).path
          break;
        case HEAD_SEARCH_CODE.RESULT_NOTICE:
          // path = (this.allMenusList.find(m => m.code === HEAD_SEARCH_CODE.PURCHASE) || {}).path
          filterType = HEAD_SEARCH_CODE.PURCHASE
          query = { ...query, noticeType: HEAD_SEARCH_CODE.RESULT_NOTICE }
          break;
        case HEAD_SEARCH_CODE.SEARCH:
          path = "/searchResult?excludeColumnId=" + NAV_MENU_CODE.ZSGG
          break;
      }
      path = path || (this.allMenusList.find(m => m.code === filterType) || {}).path
      const route = this.$router.resolve({
        path,
        query
      });
      window.open(route.href, "_self")
    }
  }
};
</script>

<style scoped lang="scss">
.header-search-view {
  width: 460px;
  height: 40px;
  border: 2px solid $--color-primary;
  ::v-deep{
    .el-input, .el-input__inner{
      height: 36px;
      border: none;
    }
  }
}
.my-search-btn {
  width: 100px;
  font-size: 14px;
  padding: 0;
  flex-shrink: 0;
  border-radius: 0;
}
</style>
